import React from "react";
import { withRouter } from "../_shared/withRouter";
import LoginComponent from "../template/auth/loginComponent";

const SuperAdminLogin = () => {
  return <LoginComponent roleType={"superadmin"} role={"1"} />;
};

export default withRouter(SuperAdminLogin);
